import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

/**
 * Minimal scroll container — uses native overflow rather than Radix ScrollArea
 * to avoid extra deps. Matches what we need for the task pane message list.
 */
export const ScrollArea = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('flex-1 overflow-y-auto overflow-x-hidden scrollbar-thin', className)}
      {...props}
    />
  ),
);
ScrollArea.displayName = 'ScrollArea';
